/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { meV4Schema } from './meV4Schema'
import { supportSummaryV4Schema } from './supportSummaryV4Schema'

export const loginAsResponseV4Schema = z
  .object({
    accessToken: z
      .string()
      .nullish()
      .describe(
        'The JWT access token to send as `Authorization: Bearer <token>`. Null while a login code is required.'
      ),
    expiresOn: z.iso
      .datetime({ offset: true, local: true })
      .nullish()
      .describe('UTC moment the access token expires. Null while a login code is required.'),
    user: z.union([meV4Schema, z.null()]).optional(),
    codeRequired: z
      .boolean()
      .optional()
      .describe(
        'True when the password was correct but a login code was emailed — post it to `auth/login/verifyCode` with `pendingToken`.'
      ),
    pendingToken: z
      .string()
      .nullish()
      .describe(
        'Opaque token identifying the pending login-code challenge. Only set when `codeRequired` is true.'
      ),
    codeSentTo: z
      .string()
      .nullish()
      .describe(
        'The masked address the code was sent to (e.g. `t***@aqode.lv`). Only set when `codeRequired` is true.'
      ),
    supportSummary: supportSummaryV4Schema
      .optional()
      .describe(
        "Summary of the target user's login blockers, shown to the support user after `loginAs`."
      ),
  })
  .describe(
    "The `loginAs` result: the normal login response plus the target's blocker summary for the support user."
  )
